import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../Components/layouts";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import customerImg from '../../Assets/images/customer.png';
import usersImg from '../../Assets/images/users.png';
import projectsImg from '../../Assets/images/projects.png';
import compProjImg from '../../Assets/images/complete-projects.png';
import Typography from '@material-ui/core/Typography';
import BarChartWrapper from '../../Components/Charts/BarChartWrapper';
import GenericTable from '../../Components/GenericTable';
import ChartContainer from '../../Components/Charts/ChartContainer';
import { Dashboard } from '../../Services/DashboardService';
import { SkillsAndTransformation } from '../../Services/SkillsAndTransformation';
import { fetchLearningHubAvailability } from '../../utils/learningHubAvailability';
import { useAuthDispatch, useAuthState } from '../../Context';
import { USER_ROLES } from '../../utils/constants';
import { useHistory } from 'react-router';
import { UserPath } from 'Routes/routePaths';
import { isEmpty } from 'lodash';
import variables from '../../Sys/variable.scss';
import { useState } from 'react';
// import UpcommingUIBanner from 'Components/UpcommingUIBanner';



const dashboardService = new Dashboard();
const skillsAndTransformation = new SkillsAndTransformation();



const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
        minHeight: 180,
        background: variables.sidebarColor,
        boxShadow: "0px 4px 30px rgba(12, 41, 84, 0.1)",
        borderRadius: 5,
        overflow: 'hidden',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            minHeight: 180,
            height: 'auto',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            minHeight: 160,
        },
    },
    cardDetails: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 1 auto',
        minWidth: 0,
        maxWidth: '100%',
        padding: theme.spacing(2),
        overflow: 'hidden',
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(2, 3),
        },
        [theme.breakpoints.between('sm', 'md')]: {
            padding: theme.spacing(1.5, 2),
        },
    },
    cover: {
        width: '100%',
        height: 120,
        paddingTop: theme.spacing(2),
        marginTop: 0,
        marginLeft: 0,
        borderRadius: '5px 5px 0 0',
        objectFit: 'contain',
        flexShrink: 0,
        [theme.breakpoints.up('sm')]: {
            width: 174,
            height: 132,
            paddingTop: 17,
            marginTop: 25,
            marginLeft: 20,
            borderRadius: 5,
        },
        [theme.breakpoints.between('sm', 'md')]: {
            width: 120,
            height: 100,
            paddingTop: theme.spacing(1.5),
            marginTop: theme.spacing(2),
            marginLeft: theme.spacing(1.5),
            flexShrink: 0,
        },
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    cardTitle: {
        color: variables.labelcolor,
        fontSize: '0.875rem',
        fontWeight: 500,
        marginBottom: theme.spacing(0.5),
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        lineHeight: 1.3,
        maxWidth: '100%',
        overflow: 'hidden',
        [theme.breakpoints.up('sm')]: {
            fontSize: '1rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            fontSize: '0.875rem',
        },
    },
    cardSubTitle: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        color: "#3D7DDD",
        fontSize: '0.75rem',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        lineHeight: 1.3,
        maxWidth: '100%',
        overflow: 'hidden',
        [theme.breakpoints.up('sm')]: {
            fontSize: '0.875rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            fontSize: '0.75rem',
        },
    },
    cardValue: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        color: "#3D7DDD",
        fontSize: '1.5rem',
        fontWeight: 600,
        marginTop: theme.spacing(0.5),
        wordBreak: 'break-word',
        [theme.breakpoints.up('sm')]: {
            fontSize: '2rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            fontSize: '1.5rem',
        },
    }
}));



const DashBoard = () => {

    const dispatch = useAuthDispatch();
    const history = useHistory();
    const { userDetails } = useAuthState(dispatch);
    const getRole = localStorage.getItem('role');

    // State for admin/customer dashboard
    const [dashboardCounts, setDashboardCounts] = useState({
        totalCustomer: 0,
        totalProjects: 0,
        totalUser: 0,
        totalClosedProjects: 0,
        totalOpenProjects: 0,
        totalUsedLicenses: 0,
        totalCourses: 0,
        totalAssesment: 0,
        totalLicense: 0,
        totalCourseRequest: 0,
        totalapprenticeship: 0
    });

    // State for user dashboard
    const [userDashboardData, setUserDashboardData] = useState({
        courses: 0,
        active_courses: 0,
        completed_courses: 0,
        learning_completion: 0
    });

    const [monthlyVisitorData, setMonthlyVisitorData] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    // const [banerOpen, setBanerOpen] = useState(false);



    React.useEffect(() => {
        let userRole = getRole || USER_ROLES.USER;

        if (userDetails) {
            if (userRole === USER_ROLES.USER) {
                getUserDashboardDetails();
                fetchLearningHubAvailability(skillsAndTransformation);
            } else {
                getDashboardDetails();
                getReportsGraphData();
                getTopUsersList();
            }
        }
    }, [userDetails]);



    // Function to fetch user dashboard data
    const getUserDashboardDetails = async () => {
        const userData = await dashboardService.getDetailDashboardUser();
        if (userData && userData.status && !isEmpty(userData.data)) {
            const { courses, active_courses, completed_courses, learning_completion } = userData.data;
            const completionAvg = learning_completion?.course_completion__avg;

            setUserDashboardData({
                courses: courses || 0,
                active_courses: active_courses || 0,
                completed_courses: completed_courses || 0,
                learning_completion: completionAvg ? Math.round(completionAvg) : 0
            });
        }
    };



    // Function to fetch admin/customer dashboard data
    const getDashboardDetails = async () => {
        let userCount = 0;
        if (getRole === USER_ROLES.SUPER_ADMIN) {
            const superAdminDashboard = await dashboardService.getDetailDashboardSuperAdmin();
            if (superAdminDashboard && superAdminDashboard.status && !isEmpty(superAdminDashboard.data)) {
                const { total_users } = superAdminDashboard.data;
                userCount = total_users;
            }
        }
        const dashBoardData = await dashboardService.getDetailDashboardCustomer();
        if (dashBoardData && dashBoardData.status && !isEmpty(dashBoardData.data)) {
            const { customer_count, open_project_count, closed_project_count, course_count, used_license_count, total_license_count, assessment_licenses, course_request_count, license_count, apprenticeship_licenses } = dashBoardData.data;
            let projects = open_project_count + closed_project_count;
            setDashboardCounts({
                totalUser: userCount,
                totalCustomer: customer_count,
                totalProjects: projects,
                totalLicense: total_license_count || license_count,
                totalClosedProjects: closed_project_count,
                totalOpenProjects: open_project_count,
                totalUsedLicenses: used_license_count,
                totalCourses: course_count,
                totalAssesment: assessment_licenses,
                totalCourseRequest: course_request_count,
                totalapprenticeship: apprenticeship_licenses
            });
        }
    };



    const getTopUsersList = async () => {
        const userList = await dashboardService.getTopCustomerAndUsers();
        if (userList?.data && userList?.data.length) {
            setCustomerList(userList.data.map((crs) => {
                return {
                    username: crs.name,
                    email: crs.email,
                    license_count: crs.license_count,
                    date: crs.project_start_date
                };
            }));
        }
    }



    const getReportsGraphData = async () => {
        const graphData = await dashboardService.getPopularCourseGraph();
        if (graphData?.data && graphData?.data.length) {
            setMonthlyVisitorData(graphData.data.map((crs) => {
                return { name: crs.course_name, count: crs.count };
            }));
        }
    };



    // Card data for Super Admin
    const cardData = [
        {
            title: 'Total Customers',
            subTitle: 'Customers',
            image: customerImg,
            totalCount: dashboardCounts.totalCustomer,
        },
        {
            title: 'Total Projects',
            subTitle: 'Projects',
            image: projectsImg,
            totalCount: dashboardCounts.totalProjects,
        },
        {
            title: 'Total Users',
            subTitle: 'Users',
            image: usersImg,
            totalCount: dashboardCounts.totalUser,
        },
        {
            title: 'Total Licenses',
            subTitle: 'Licenses',
            image: compProjImg,
            totalCount: dashboardCounts.totalLicense,
        },
        {
            title: 'Total Completed Projects',
            subTitle: 'Completed Projects',
            image: projectsImg,
            totalCount: dashboardCounts.totalClosedProjects,
        },
        {
            title: 'Total Open Projects',
            subTitle: 'Open Projects',
            image: compProjImg,
            totalCount: dashboardCounts.totalOpenProjects,
        },
        {
            title: 'Total Number of Used Licenses for Customer',
            subTitle: 'Used Licenses for Customer',
            image: usersImg,
            totalCount: dashboardCounts.totalUsedLicenses
        }
    ];



    // Card data for Customer Admin
    const customerCardData = [
        {
            title: 'Total Open Projects',
            subTitle: 'Open Projects',
            image: customerImg,
            totalCount: dashboardCounts.totalOpenProjects,
        },
        {
            title: 'Total Closed Projects',
            subTitle: 'Closed Projects',
            image: projectsImg,
            totalCount: dashboardCounts.totalClosedProjects,
        },
        {
            title: 'Total Course Requests',
            subTitle: 'Course Requests',
            image: usersImg,
            totalCount: dashboardCounts.totalCourseRequest,
        },
        {
            title: 'Skills',
            subTitle: 'Skills Transformation',
            image: compProjImg,
            totalCount: '0',
        },
        {
            title: 'Apprenticeships Counts',
            subTitle: 'Total Apprenticeship Counts',
            image: projectsImg,
            totalCount: dashboardCounts?.totalapprenticeship || "0",
        },
        {
            title: 'Assessments Due',
            subTitle: 'Assessments',
            image: usersImg,
            totalCount: dashboardCounts.totalAssesment,
        },
        {
            title: 'License Counts',
            subTitle: 'Total License Counts',
            image: compProjImg,
            totalCount: dashboardCounts.totalLicense,
        }
    ];



    // Card data for User
    const userCardData = [
        {
            title: 'Total Courses',
            subTitle: 'Courses',
            image: projectsImg,
            totalCount: userDashboardData.courses,
        },
        {
            title: 'Active Courses',
            subTitle: 'Active',
            image: customerImg,
            totalCount: userDashboardData.active_courses,
        },
        {
            title: 'Completed Courses',
            subTitle: 'Completed',
            image: compProjImg,
            totalCount: userDashboardData.completed_courses,
        },
        {
            title: 'Learning Progress',
            subTitle: 'Average Completion',
            image: usersImg,
            totalCount: `${userDashboardData.learning_completion}%`,
        }
    ];



    // Select appropriate cards based on role
    let cards = getRole === USER_ROLES.SUPER_ADMIN
        ? cardData
        : getRole === USER_ROLES.USER
            ? userCardData
            : customerCardData;



    const classes = useStyles();
    return (
        <Layout>
            <main style={{ width: '100%', padding: 0 }}>
                <Grid container spacing={2}>
                    {cards.map((item) => (
                        <Grid key={item.title} item xs={12} sm={6} md={6} lg={6} xl={4}>
                            <Card className={classes.root}>
                                <CardMedia
                                    className={classes.cover}
                                    image={item.image}
                                    title={item.title}
                                />
                                <CardContent className={classes.content}>
                                    <Typography className={classes.cardTitle}>
                                        {item.title}
                                    </Typography>
                                    <Typography className={classes.cardSubTitle}>
                                        {item.subTitle}
                                    </Typography>
                                    <Typography className={classes.cardValue}>
                                        {item.totalCount}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

                {getRole === USER_ROLES.SUPER_ADMIN ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <ChartContainer
                                styleOveride={{
                                    background: variables.sidebarColor,
                                    borderRadius: 12,
                                    marginTop: 32,
                                    padding: 10,
                                    width: '100%',
                                    overflow: 'auto'
                                }}
                                title={"Monthly Visitor"}
                            >
                                <BarChartWrapper data={monthlyVisitorData} />
                            </ChartContainer>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <ChartContainer
                                styleOveride={{
                                    background: variables.sidebarColor,
                                    borderRadius: 12,
                                    marginTop: 32,
                                    padding: 10,
                                    width: '100%',
                                    overflow: 'auto'
                                }}
                                title={"Top Customers/users"}
                            >
                                <GenericTable
                                    columns={[
                                        { label: "Username", key: 'username' },
                                        { label: "Learner Email", key: "email" },
                                        { label: "License count", key: "license_count" },
                                        { label: "Date", key: "date" }
                                    ]}
                                    applyMinWidth={false}
                                    list={customerList}
                                />
                            </ChartContainer>
                        </Grid>
                    </Grid>
                ) : null}

                {userDetails && getRole !== USER_ROLES.USER ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <ChartContainer
                                styleOveride={{
                                    background: variables.sidebarColor,
                                    borderRadius: 12,
                                    marginTop: 32,
                                    padding: 10,
                                    width: '100%',
                                    overflow: 'auto'
                                }}
                                title={userDetails.role === USER_ROLES.SUPER_ADMIN ? "Check Customer Growth" : "Check Courses Growth"}
                            >
                                <BarChartWrapper data={monthlyVisitorData} />
                            </ChartContainer>
                        </Grid>
                    </Grid>
                ) : null}

                {/* <UpcommingUIBanner open={banerOpen} handleClose={evt => setBanerOpen(false)} /> */}
            </main>
        </Layout>
    );
}



export default DashBoard;
